<template>
  <div class="page-table year-statistics">
    <div class="page-search" style="margin:0;border:none;">
      <a-form>
        <a-row>
          <a-col :span="6">
            <a-form-item label="年份" :labelCol="{span: 3}" :wrapperCol="{span: 17}">
              <a-select
                :options="yearOptions"
                placeholder="请选择"
                v-model="searchYear"
                @change="yearchange"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="page-search">
      <a-col
        v-for="(nvaList,index) in nvaList"
        :key="index"
        class="navtabs"
        :class="'navtab'+index"
        @click="jumptorepaire(nvaList)"
        :style="navspan"
      >
      <div class="img"></div>
        <div class="content">
          <p>{{nvaList.key}}</p>
          <div class="mums">{{nvaList.value}}</div>
        </div>
      </a-col>
    </div>
    <a-row class="thistopnav">
      <div class="table-operator" style="width: calc((100% - 100px) / 4 + 20px);">
        <div class="page-search">
            <a-row>
              <a-col class="warp-title" :span="24">报修单状态占比</a-col>
            </a-row>
        </div>
        <div class="btndivright">
          <a-button @click="seeMore('stasetForm')">查看明细</a-button>
        </div>
        <div id="staseChart" :style="{width: '100%', height: '400px'}"></div>
      </div>
      <div class="table-operator" style="width: calc(100% - ((100% - 100px) / 4 + 30px));">
        <div class="page-search">
          <a-row>
            <a-col class="warp-title" :span="24">月度报修单统计</a-col>
          </a-row>
        </div>
        <div id="fullChart" :style="{width: '100%', height: '442px', textAlign: 'left'}"></div>
      </div>
    </a-row>
  </div>
</template>

<script>
import './work.less'
export default {
  name: 'QueryList',
  data () {
    return {
      roleqx: {},
      searchYear: undefined,
      form: this.$form.createForm(this),
      yearOptions: [],
      nvaList: [],
      navspan: '',
      pieoneData: {},
      pieoneData2: {},
      stasetdates: {}
    }
  },
  mounted () {
    this.getYearDict()
    // 获取权限
    this.getRoles()
  },
  methods: {
    getYearDict () {
      this.$axios.post('/api/common/getYearList.do').then(res => {
        this.yearOptions = res.data.list || []
        this.searchYear = res.data.list[0].value
      })
    },
    // 获取权限
    getRoles () {
      this.$axios.post('/api/roleMenu/getRoles.do').then(res => {
        if (!res.data.roles[0]) {
          this.$router.push({ path: '/403', query: {} })
        } else {
          this.roleqx = res.data.roles[0]
          // 获取数据
          this.getpiedata()
        }
      })
    },
    // 数据转化
    getDate (data) {
      var maindata = []
      for (var i = 0; i < data.labels.length; i++) {
        maindata.push({
          name: data.labels[i],
          value: data.colValues[0][i]
        })
      }
      var pieoneData = {
        text: data.labels,
        data: maindata,
        value: data.colValues[0]
      }
      return pieoneData
    },
    yearchange () {
      this.getpiedata()
    },
    // 报修单状态
    getpiedata () {
      let params = {
        year: this.searchYear
      }
      this.$axios.post('/api/gzt/ndtjNew.do', params).then(res => {
        var deswidth = 20 * (res.data.guaranteeStatus.length - 1)
        this.navspan =
          'width:calc((100% - ' +
          deswidth +
          'px)/' +
          res.data.guaranteeStatus.length +
          ')'
        this.nvaList = res.data.guaranteeStatus || []
        this.drawpie(this.getDate(res.data.pieChart))
        this.drawBar(res.data.histogram)
      })
    },
    drawpie (pieoneData) {
      let labels = {
        position: 'inside',
        formatter: '{b}({c})'
      }
      for (var i = 0; i < pieoneData.data.length; i++) {
        pieoneData.data[i].label = labels
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('staseChart'))
      // 绘制图表
      myChart.setOption({
        color: [
          '#4472c4',
          '#ed7d31',
          '#a5a5a5',
          '#ffc000',
          '#5b9bd5',
          '#70ad47',
          '#264478',
          '#d33200',
          '#5252c1'
        ],
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 40,
          left: 'center',
          data: pieoneData.text
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '35%'],
            selectedMode: 'single',
            data: pieoneData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    drawBar (barData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('fullChart'))
      // 绘制图表
      myChart.setOption({
        color: [
          '#4472c4',
          '#ed7d31',
          '#a5a5a5',
          '#ffc000',
          '#5b9bd5',
          '#70ad47',
          '#264478',
          '#d33200',
          '#5252c1'
        ],
        title: {
          text: '',
          left: 'center'
        },
        grid: {
          left: '40px',
          right: '40px',
          bottom: '40px',
          top: '40px'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            const html = params[0].axisValue + '<br /> <div style="display:inline-block;margin-right: 6px;width: 14px;height: 10px;background:' +
            params[0].color + '"></div>' + params[0].seriesName + '： ' + params[0].value + '<br /> <div style="display:inline-block;margin-right: 6px;width: 14px;height: 10px;background:' +
            params[1].color + '"></div>' + params[1].seriesName + '： ' + params[1].value + '<br /> <div style="display:inline-block;margin-right: 6px;width: 14px;height: 10px;background: #a5a5a5;"></div>总数： ' + (Number(params[0].value) + Number(params[1].value))
            return html
          }
        },
        xAxis: {
          data: barData.month
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: '维修完成',
            type: 'bar',
            stack: 'repair',
            data: barData.finish,
            barWidth: '20',
            barGap: '50%'
          },
          {
            name: '维修未完成',
            type: 'bar',
            stack: 'repair',
            data: barData.notFinish,
            barWidth: '20',
            barGap: '50%'
          }
        ]
      })
    },
    // 查看更多/明细
    seeMore (formname) {
      this.$router.push({ path: '/repair' })
    },
    // 头部跳转
    jumptorepaire (list) {
      if (list.status) {
        this.$router.push({ path: '/repair', query: { type: list.status } })
      }
    }
  }
}
</script>
